// src/utils/readUrlParams.ts

type UrlParams = Record<string, string | unknown>

/**
 * Reads current URL query params and returns a plain object.
 * - Normal params -> string
 * - JSON params (default: "sort", "filter") -> parsed object/array
 *
 * Usage:
 *   const params = readUrlParams();
 *   // { view: "active", scope: "my", sort: [{ direction: "asc", field: "term_name" }] }
 */
export const readUrlParams = (jsonKeys: string[] = ['sort', 'filter']): UrlParams => {
  const searchParams = new URLSearchParams(window.location.search)
  const params: UrlParams = {}

  for (const [key, value] of searchParams.entries()) {
    params[key] = value
  }

  return params
}
